import React, { useEffect, useMemo, useRef, useState } from "react";
import { getSnapshot } from "mobx-state-tree";
import { observer } from "mobx-react";
import { Button, Form, Modal } from "react-bootstrap";

import { useAppStore } from "../../../providers/AppStoreProvider";
import { useAPI } from "../../../providers/ApiProvider";
import { toastWithAsyncFetch } from "../../../utils/helper";
import { FormStep } from "./FormStep";
import { BaseForm } from "./BaseForm";
import { AdditionalForm } from "./AdditionalForm";
import { ContentForm } from "./ContentForm";

import "./LessonModal.scss";

export const LessonModal = observer(() => {
  const store = useAppStore();
  const api = useAPI();
  const modalRef = useRef();
  const [step, setStep] = useState(1);
  const [dangerConfirming, setDangerConfirming] = useState(false);
  const [confirmBtnText, setConfirmBtnText] = useState("Tạo bài học");

  const lessonBaseRef = useRef();
  const lessonContentRef = useRef();

  useEffect(() => {
    modalRef.current.dialog?.scrollTo(0, 0);

    switch (step) {
      case 1:
        setConfirmBtnText(`${store.lessonModal.mode === "edit" ? "Sửa" : "Tạo"} bài học`);
        break;
      case 2:
        setConfirmBtnText("Sửa nội dung bài học");
        break;
    }
  }, [step, store.lessonModal.show]);

  const currentLesson = useMemo(
    () =>
      store.lessonModal.entityId
        ? store.lessons.find((l) => l.id === store.lessonModal.entityId)
        : null,
    [store.lessonModal.entityId],
  );

  const hideModalHandler = () => {
    store.lessonModal.toggle();
    setTimeout(() => {
      setStep(1);
      setDangerConfirming(false);
      store.lessonModal.setEntityId(null);
    }, 500);
  };

  const submitHandler = () => {
    switch (step) {
      case 1:
        const lessonData = lessonBaseRef.current.getBaseData();

        if (store.lessonModal.mode === "edit") {
          const lesson = store.lessons.find((l) => l.id === currentLesson.id);

          if (lesson) {
            toastWithAsyncFetch(
              {
                loading: "Đang sửa bài học...",
                success: "Sửa bài học thành công",
                error: "Sửa bài học thất bại",
              },
              api.callApi.bind(null, "updateLesson", {
                params: { pk: lesson.id, chapterId: lessonData.chapter },
                body: lessonData,
              }),
              (res) => {
                currentLesson.update(res.data.data.lesson);
              },
            );
          }
        } else {
          toastWithAsyncFetch(
            {
              loading: "Đang tạo bài học...",
              success: "Tạo bài học thành công",
              error: "Tạo bài học thất bại",
            },
            api.callApi.bind(null, "createLesson", {
              params: { chapterId: lessonData.chapter },
              body: lessonData,
            }),
            (res) => {
              const l = res.data.data.lesson;

              store.createLesson(l);
              store.setCurrentLesson(l.id);
              store.lessonModal.setMode("edit");
              store.lessonModal.setEntityId(l.id);
              setStep(2);
            },
          );
        }
        break;
      case 2:
        toastWithAsyncFetch(
          {
            loading: "Đang sửa nội dung bài học...",
            success: "Sửa nội dung bài học thành công",
            error: "Sửa nội dung bài học thất bại",
          },
          api.callApi.bind(null, "updateLessonContent", {
            params: { pk: currentLesson.id },
            body: {
              ...lessonContentRef.current.getVideoData(),
              url: currentLesson.video.url,
            },
          }),
          (res) => {
            currentLesson.update(res.data.data.lesson);
          },
        );
        break;
      case 3:
        hideModalHandler();
        break;
    }
  };

  return (
    <Modal
      size="lg"
      ref={modalRef}
      show={store.lessonModal.show}
      onHide={hideModalHandler}
      className="lesson-modal"
      backdrop="static"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title as="h3" className="fw-bold">
          {store.lessonModal.mode === "edit" ? "Sửa" : "Tạo"} bài học
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormStep step={step} setStep={setStep} />

        <Form onSubmit={(e) => e.preventDefault()}>
          {step === 1 && (
            <BaseForm
              ref={lessonBaseRef}
              onHideModal={hideModalHandler}
              dangerConfirming={dangerConfirming}
              setDangerConfirming={setDangerConfirming}
              currentLesson={currentLesson}
            />
          )}
          {step === 2 && <ContentForm ref={lessonContentRef} currentLesson={currentLesson} />}
          {step === 3 && <AdditionalForm currentLesson={currentLesson} />}
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0">
        {/* {step > 1 && (
          <Button
            variant="outline"
            className="outline-0 text-black-50 rounded-pill p-2 px-4"
            onClick={() => setStep((currState) => currState - 1)}
          >
            Quay lại
          </Button>
        )} */}
        {(step === 1 || (step === 2 && currentLesson.lesson_type === "video")) && (
          <Button
            className="fw-bold rounded-pill bg-gradient-orange border-0 p-2 px-4"
            onClick={submitHandler}
          >
            {confirmBtnText}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
});
